import { Component, OnInit, Input } from "@angular/core";
import { NgFor, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-dashboardnotifications",
  templateUrl: "./dashboardnotifications.component.html",
  styleUrls: ["./dashboardnotifications.component.scss"],
  imports: [NgFor, NgIf, RouterLink, TranslatePipe],
})
export class DashboardnotificationsComponent implements OnInit {
  @Input() notification;
  text = [];
  constructor() {}

  ngOnInit(): void {
    if (this.notification) {
      this.text = this.notification;
    }
  }
}

export interface Notification {
  message: string;
  link?: boolean;
  link_text?: string;
  url?: string;
}

export class NotificationType {
  public static noDevice: Notification = {
    message: "notification.NODEVICE",
  };

  public static noResource: Notification = {
    message: "notification.NORESOURCE.message",
    link: true,
    url: "/resources",
    link_text: "notification.NORESOURCE.link",
  };

  public static noOrgData: Notification = {
    message: "notification.NOTELEPHONE.message",
    link: true,
    url: "/account/organizationprofile",
    link_text: "notification.NOTELEPHONE.link",
  };
}
